<template>
  <div>
    <onboarding-question
      v-for="(onboardingStep, index) in onboardingSteps"
      :key="onboardingStep.id"
      :onboarding-step="onboardingStep"
      @next="goNext"
      @back="goBack"
      :show-back="!isFirstStep"
      v-show="index === currentStep"
    />
  </div>
</template>
<script>
import OnboardingQuestion from './onboarding-question.vue';

export default {
  components: { OnboardingQuestion },
  data() {
    return {
      currentStep: 0,
    };
  },
  props: {
    onboardingSteps: {
      type: Array,
      required: true,
    },
  },
  methods: {
    goNext() {
      if (this.isLastStep) {
        this.$emit('next');
      } else {
        this.currentStep += 1;
      }
    },
    goBack() {
      if (!this.isFirstStep) {
        this.currentStep -= 1;
      }
    },
  },
  computed: {
    isLastStep() {
      return this.currentStep === this.onboardingSteps.length - 1;
    },
    isFirstStep() {
      return this.currentStep === 0;
    },
  },
};
</script>
